<script>
import api from "@modules/JourneyBuilder/api";
import {errorGrowl} from "@core/Util/growler";

import BrickCustomConditions from "../BrickCustomConditions";

export default {
    name: "GoalCustomConditions",
    
    props: {
        value: {
            type: Array,
            required: true
        },
        
        goalType: {
            type: Number,
            required: false
        }
    },

    data() {
        return {
            isLoading: true,
            fields: []
        }
    },

    computed: {
        availableFields() {
            //A type is available when it is:
            // * Global (= no goalTypes)
            // * Linked to our goalType (= goalTypes contains our given goalType)
            return this.fields.filter(field =>
                !field.goalTypes.length ||
                field.goalTypes.includes(this.goalType)
            );
        }
    },

    watch: {
        isLoading(value) {
            this.$emit('loading-state-changed', value);
        }
    },

    created() {
        this.loadCustomGoalFields();
    },

    methods: {
        async loadCustomGoalFields() {
            this.isLoading = true;

            try {
                this.fields = await api.getCustomGoalFields();
            } catch (e) {
                errorGrowl(e);

                this.fields = [];
            } finally {
                this.isLoading = false;
            }
        },

        triggerValidations() {
            if(this.$refs.customConditions) {
                this.$refs.customConditions.triggerValidations();
            }
        }
    },

    render(createElement, context) {
        return createElement(BrickCustomConditions, {
            props: {
                fields: this.availableFields,
                value: this.value,
                isLoading: this.isLoading
            },

            on: {
                input: $event => this.$emit('input', $event),

                'validation-state-changed': $event => this.$emit('validation-state-changed', $event)
            },

            ref: 'customConditions'
        });
    }
}
</script>
